import { IconWrapper, StyledShapeIcon } from "../../setup-list.styles";
import { ShapeIconProps, Typography } from "@flash-tecnologia/hros-web-ui-v2";
import {
  ActionWrapper,
  Container,
  TextContainer,
} from "./setup-list-item.styles";
import { Step } from "bff/src/services";

export interface SetupListItemProps {
  step: Step;
  isLast?: boolean;
  actionSlot?: React.ReactNode;
}

export const SetupListItem = ({
  step,
  isLast,
  actionSlot,
}: SetupListItemProps) => {
  return (
    <Container>
      <IconWrapper isLast={isLast} isListItem>
        <StyledShapeIcon size={24} {...getIconProps(step.status)} />
      </IconWrapper>
      <TextContainer isSkipped={step.status === "SKIPPED"}>
        <Typography variant="headline10" color="neutral.20">
          {step.title}
        </Typography>
        <Typography variant="caption" color="neutral.40">
          {step.description}
        </Typography>
      </TextContainer>
      {actionSlot && <ActionWrapper>{actionSlot}</ActionWrapper>}
    </Container>
  );
};

const getIconProps = (
  status: Step["status"]
): Pick<ShapeIconProps, "name" | "variant" | "color"> => {
  switch (status) {
    case "SKIPPED":
      return {
        name: "IconLineDashed",
        variant: "neutral",
        color: "var(--color-neutral-40)",
      };
    case "DOING":
      return {
        name: "IconProgress",
        variant: "progress",
        color: "var(--color-feedback-progress-40)",
      };
    case "COMPLETED":
      return {
        name: "IconCheck",
        variant: "success",
        color: "var(--color-feedback-success-40)",
      };
    case "PENDING":
    default:
      return {
        name: "IconProgress",
        variant: "neutral",
        color: "var(--color-neutral-40)",
      };
  }
};
